import { render, staticRenderFns } from "./ButtonSwitch.vue?vue&type=template&id=0fe50b6e&scoped=true"
import script from "./ButtonSwitch.vue?vue&type=script&lang=js"
export * from "./ButtonSwitch.vue?vue&type=script&lang=js"
import style0 from "./ButtonSwitch.vue?vue&type=style&index=0&id=0fe50b6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe50b6e",
  null
  
)

export default component.exports